module.exports = __webpack_public_path__ + "static/images/challenge.d6955676d0514654e1670e32e2217fe1.png";